import { useState } from "react";
import { Link } from "react-router-dom";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { AdminTable } from "../../components/admin/AdminTable";
import { Badge } from "../../components/ui/Badge";
import { EmptyState } from "../../components/ui/EmptyState";
import { Input } from "../../components/ui/Input";
import { FullPageLoader } from "../../components/ui/FullPageLoader";
import { useTenants } from "../../hooks/useTenants";
import { formatDate, formatDateTime, statusTone } from "../../lib/format";

export function AdminTenantsPage() {
  const [search, setSearch] = useState("");
  const { data: tenants, loading, error } = useTenants(search);

  return (
    <div>
      <AdminPageHeader
        title="Tenants"
        description="Search and control every workspace on the platform."
      />

      <div className="mb-5 max-w-md">
        <Input
          label="Search tenants"
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Name or slug"
          value={search}
        />
      </div>

      {loading ? <FullPageLoader label="Loading tenants" /> : null}
      {error ? <EmptyState title="Unable to load tenants.">{error}</EmptyState> : null}

      {!loading && !error ? (
        tenants?.length ? (
          <AdminTable headers={["Name", "Slug", "Owner", "Status", "Plan", "Trial expires", "Members", "Created", "Actions"]}>
            {tenants.map((tenant) => (
              <tr key={tenant.id}>
                <td className="px-4 py-3 font-medium text-ink">{tenant.name}</td>
                <td className="px-4 py-3 text-graphite/70">{tenant.slug}</td>
                <td className="px-4 py-3">{tenant.profiles?.email ?? "No owner"}</td>
                <td className="px-4 py-3">
                  <Badge tone={statusTone(tenant.status)}>{tenant.status}</Badge>
                </td>
                <td className="px-4 py-3">{tenant.plan}</td>
                <td className="px-4 py-3">{formatDateTime(tenant.trial_expires_at)}</td>
                <td className="px-4 py-3">{tenant.member_count ?? 0}</td>
                <td className="px-4 py-3">{formatDate(tenant.created_at)}</td>
                <td className="px-4 py-3">
                  <Link className="link" to={`/admin/tenants/${tenant.id}`}>
                    Open
                  </Link>
                </td>
              </tr>
            ))}
          </AdminTable>
        ) : (
          <EmptyState title="No tenants found.">Create a new workspace invite to start tenant setup.</EmptyState>
        )
      ) : null}
    </div>
  );
}
